import React, {Component} from 'react';
import { Row } from 'react-flexbox-grid';
import Card from "./Card";
import './Group.css';
import Mansory from 'react-masonry-component';

class Group extends Component {

    render() {
        return (
            <div className="Maintenant-Group">
                <h1>{this.props.name}</h1>
                <Row>
                    <Mansory style={{width: '100%'}} className="row">
                        {this.props.entries.map((entry) => {
                            return <Card entry={entry} format={this.props.format} key={entry.id}/>
                        })}
                    </Mansory>
                </Row>
            </div>
        );
    }
}

export default Group;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards/Group.js